<template>
  <div class="cruise_search partner-search">
    <div class="container">
      <div class="row">
        <div class="search-switch-tabbar">
          <div
            class="search-switch-btn search-switch-hp"
            :class="{ active: showContainer == 'hp' }"
            @click="changeShowContainer('hp')"
          >
            中国出发航线
          </div>
          <div
            class="search-switch-btn search-switch-row"
            :class="{ active: showContainer == 'row' }"
            @click="changeShowContainer('row')"
          >
            海外出发航线
          </div>
        </div>
        <SearchBarContainer
          :cruiseType="'hp'"
          :cruiseFilters="cruiseFilters"
          :style="shouldShowContainer('hp')"
        />
        <SearchBarContainer
          :cruiseType="'row'"
          :cruiseFilters="cruiseFilters"
          :rowCruiseSearchHandler="rowCruiseSearchHandler"
          :style="shouldShowContainer('row')"
        />
      </div>
    </div>
  </div>
</template>

<script>
const SearchBarContainer = () =>
  import("@/components/SearchBar/SearchBarContainer");

export default {
  name: "SearchBar",
  components: {
    SearchBarContainer,
  },
  props: {
    cruiseFilters: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isShowHp: {
      type: Boolean,
      default() {
        return true;
      },
    },
    rowCruiseSearchHandler: {
      type: Function,
    },
  },
  data() {
    return {
      showContainer: "hp",
    };
  },
  beforeMount() {
    this.$store.dispatch("RESET_CRUISE_FILTERS");
    this.showContainer = this.isShowHp ? "hp" : "row";
  },
  methods: {
    changeShowContainer(container) {
      this.showContainer = container;
    },
    shouldShowContainer(container) {
      if (this.showContainer == container) {
        return {
          display: "block",
        };
      } else {
        return {
          display: "none",
        };
      }
    },
  },
  computed: {},
  watch: {
    isShowHp(newValue) {
      this.showContainer = newValue ? "hp" : "row";
    },
  },
};
</script>

<style>
.cruise_search .line {
  position: absolute;
  left: 0;
  top: 65px;
  height: 0px;
  border-bottom: solid 1px #449bd1;
  margin: 0px 17px;
  width: 1150px;
}

.row-search-container {
  display: none;
}

/* 航线搜索下拉 */
.departure-area-name.search-form-title {
}

.cruise_search {
  position: relative;
  z-index: 10;
  margin-top: 0px;
}

.cruise_search .container {
  width: 1200px;
  /* background-color: white; */
  -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
}

.cruise_search .row {
  position: relative;
}

/* 航线切换 */
.cruise_search .row .search-switch-tabbar {
  position: absolute;
  top: -35px;
  left: 0;
  width: 433px;
}

.cruise_search .row .search-switch-tabbar .search-switch-btn {
  width: 212px;
  height: 35px;
  color: white;
  display: inline-block;
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  background: url(https://resource.rcclchina.com.cn/cruiseSearch/search-switch-tab-no.png)
    top left no-repeat;
  position: relative;
}

.cruise_search .row .search-switch-tabbar .search-switch-btn.search-switch-hp {
  background: rgba(0, 0, 0, 0.7);
  z-index: 1;
}

.cruise_search .row .search-switch-tabbar .search-switch-btn.search-switch-row {
  left: -32px;
  z-index: 0;
}

.cruise_search .row .search-switch-tabbar .search-switch-btn.active {
  color: #2873bb;
  background: url(https://resource.rcclchina.com.cn/cruiseSearch/search-switch-tab.png)
    top left no-repeat;
}

.cruise_search
  .row
  .search-switch-tabbar
  .search-switch-btn.active:nth-child(2) {
  background: url(https://resource.rcclchina.com.cn/cruiseSearch/search-switch-tab-2.png)
    top left no-repeat;
}

.cruise_search
  .row
  .search-switch-tabbar
  .search-switch-btn.search-switch-row.active {
  z-index: 2;
}

.cruise_search .cruise-search-bar-container {
  background-color: white;
}

.cruise_search #hp_search.search_container,
.cruise_search #row_search.search_container {
  position: relative;
  height: 90px;
  margin: 0px;
  padding: 10px 0px;
  z-index: 10;
}

.container .row #hp_search .chosen-wrap,
.container .row #row_search .chosen-wrap {
  display: inline-block;
  height: 100%;
  padding: 12px 20px 0px 25px;
  margin-right: 0;
  border-radius: 0px;
  margin: 0;
}

.container .row #hp_search .departureCodes,
.container .row #row_search .departureCodes {
  width: 290px !important;
  border-right: solid 1px #cdd6d9;
}

.container .row #hp_search .sailDates,
.container .row #row_search .sailDates {
  width: 250px !important;
  border-right: solid 1px #cdd6d9;
}

.container .row #hp_search .destinationCodes,
.container .row #row_search .destinationCodes {
  width: 480px !important;
}

#hp_search .chosen-wrap .chosen-drop,
#row_search .chosen-wrap .chosen-drop {
  background-color: #ebeff1;
}
.cruise_search #hp_search .chosen-container,
.cruise_search #row_search .chosen-container {
  background-color: transparent;
}
#hp_search .chosen-container .chosen-wrap.active .chosen-drop,
#row_search .chosen-container .chosen-wrap.active .chosen-drop {
  display: block;
}
.cruise_search #hp_search #searchCruiseH,
.cruise_search #row_search #searchCruiseH {
  width: 170px;
  height: 90px;
  margin-top: -10px;
  float: right;
}
#hp_search #searchCruiseH .search_button,
#row_search #searchCruiseH .search_button {
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  height: 100%;
  margin-top: 0px;
  color: white;
  background-color: #0073bb;
  padding: 0px;
  border-radius: 0px;
}

#hp_search #searchCruiseH .search_button:hover,
#row_search #searchCruiseH .search_button:hover {
  background-color: #54a3de;
}

.search_container .chosen-container {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.search_container .chosen-container .chosen-single {
  position: relative;
  cursor: pointer;
  z-index: 1;
  color: #333;
  padding: 0px;
  margin-top: 0px;
}

.search_container .chosen-single.chosen {
  color: #051854;
}

.search_container .chosen-container .chosen-single img {
  margin-top: -4px;
  margin-right: 4px;
  width: 16px;
}

.search_container .chosen-container .chosen-content span {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.search_container .chosen-container .chosen-content span.item-empty {
  color: #a6aeb1;
}

.search_container .chosen-container .chosen-single span.badge {
  position: relative;
  top: -2px;
  left: 5px;
  background-color: #2873bb;
  font-weight: normal;
  min-width: 20px;
  min-height: 20px;
  padding-top: 4px;
}

.search_container .chosen-container .chosen-single .chosen-bind {
  font-size: 14px;
  color: #747d80;
  font-weight: bold;
  margin-top: 5px;
}

.search_container .chosen-container .chosen-single .chosen-content {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-top: 4px;
}

.search_container .chosen-container .chosen-single .search-select-arrow {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-top: 4px;
  float: right;
  color: #0066cc;
  border: solid currentColor;
  border-width: 0 1px 1px 0;
  transform: rotate(45deg);
}

.search_container .chosen-container .chosen-content img {
  float: right;
  margin-top: 2px;
  margin-right: 0px;
}

.search_container .chosen-container:focus,
.search_container .chosen-single:focus {
  outline: none !important;
}

.cruise_search .search_form {
  position: absolute;
  width: 100%;
  left: 0;
  top: 90px;
  color: white;
  z-index: 10;
  font-size: 14px;
  font-weight: 400;
}

.cruise_search .search_form .search-form-container {
  position: relative;
  padding: 25px 8px;
  background-color: #0073bb;
  text-align: left;
  box-shadow: 0.643px 0.766px 18px 0px rgba(0, 0, 0, 0.09);
}

.cruise_search .search_form .search-form-container .search-form-clear {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.cruise_search .search_form .search-form-container .search-form-clear img {
  position: relative;
  top: -2px;
}

.cruise_search .search_form .search-form-item {
  display: inline-block;
  vertical-align: top;
  margin-left: 20px;
  position: relative;
}

.cruise_search .search_form .search-form-item ~ .search-form-item {
  margin-left: 85px;
}

.cruise_search .search_form .search-form-item.departure-area {
  width: 210px;
  margin-left: 0px;
}

.cruise_search .search_form .search-form-item.departure-area:first-child {
  margin-left: 20px;
}

.cruise_search .search_form .search-form-item-group {
  display: inline-block;
  vertical-align: top;
  margin-left: 85px;
}

.cruise_search .search_form .search-form-item-group .search-form-item {
  display: block;
  margin-left: 0px;
  margin-bottom: 25px;
}

.cruise_search .search_form .search-form-item .search-form-title {
  font-weight: bold;
  font-size: 18px;
  position: relative;
  left: 18px;
  padding-bottom: 8px;
}

.cruise_search .search_form .search-form-item .search-form-list {
  margin-top: 10px;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item {
  margin-bottom: 15px;
  cursor: pointer;
}

.cruise_search
  .row-search-container
  .search_form
  .departure-area
  .departure-area-list {
  margin-top: 33px;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-nochecked,
.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-checked {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-nochecked
  img,
.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-checked
  img {
  position: relative;
  top: -1px;
}

.cruise_search .search_form .search-form-item img {
  width: 100%;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.active,
.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item:hover {
  color: #ffcd00;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.disable {
  color: #87acc3;
  cursor: not-allowed;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.cruiseDisable {
  color: #87acc3;
  cursor: not-allowed;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-title.destination-area-name.cruiseDisable {
  color: #87acc3;
  cursor: not-allowed;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-nochecked {
  display: inline-block;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.active
  .search-form-list-item-nochecked {
  display: none;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item
  .search-form-list-item-checked,
.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.disable
  .search-form-list-item-checked {
  display: none;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item.active
  .search-form-list-item-checked {
  display: inline-block;
}

.cruise_search .search_form .sailDate-search-form {
  padding: 38px 8px 25px;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-container {
  position: relative;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-wrapper
  .sailDate-search-form-slider {
  display: none;
  padding: 0px 30px;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-wrapper
  .sailDate-search-form-slider.active {
  display: block;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-wrapper
  .sailDate-search-form-slider
  .sailDate-search-form-content {
  display: inline-block;
  vertical-align: top;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-wrapper
  .sailDate-search-form-slider
  .sailDate-search-form-separator {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 1px;
  height: 150px;
  background-color: #d4dbde;
  top: 40px;
  margin: 0px 15px;
}

.cruise_search .search_form .sailDate-search-form .sailDate-search-form-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-month-line {
  margin-top: 15px;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-month-line
  .sailDate-search-form-month {
  display: inline-block;
  width: 75px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-month-line
  .sailDate-search-form-month.disable {
  color: #87acc3;
  cursor: not-allowed;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-month-line
  .sailDate-search-form-month:hover {
  background-color: #54a3de;
}

.cruise_search
  .search_form
  .sailDate-search-form
  .sailDate-search-form-month-line
  .sailDate-search-form-month.active {
  background-color: white;
  color: #2873bb;
}

.cruise_search .search_form .sailDate-search-form .switch-arrow {
  position: absolute;
  top: 0px;
  width: 25px;
  height: 25px;
  left: 10px;
  cursor: pointer;
}

.cruise_search .search_form .sailDate-search-form .switch-arrow img {
  position: relative;
  width: 9px;
  left: 7px;
}

.cruise_search .search_form .sailDate-search-form .right-arrow {
  left: auto;
  right: 10px;
}

/* 目的地 */

.cruise_search .search_form .destination-search-form .search-form-country {
  padding: 0 38px;
  font-size: 18px;
  font-weight: bold;
  border-bottom: solid 1px rgba(68, 155, 210, 0.6);
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-country
  .search-form-country-item {
  display: inline-block;
  vertical-align: top;
  margin-left: 70px;
  padding-bottom: 10px;
  cursor: pointer;
  min-width: 150px;
  text-align: center;
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-country
  .search-form-country-item.search-form-country-item-large {
  width: 240px;
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-country
  .search-form-country-item:first-child {
  margin-left: 0;
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-country
  .search-form-country-item.active {
  color: #ffcd00;
  border-bottom: solid 2px #ffcd00;
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-item-container {
  display: none;
  margin-top: 20px;
  padding-left: 36px;
}

.cruise_search
  .search_form
  .destination-search-form
  .search-form-item-container.active {
  display: block;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-title.destination-area-name {
  font-size: 17px;
  position: relative;
  left: -10px;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-title.destination-area-name
  .item-line {
  width: 4px;
  height: 18px;
  background-color: #ffcd00;
  display: inline-block;
  vertical-align: middle;
  border-radius: 2px;
}

.cruise_search .search_form .search-form-item .flag-content {
  display: inline-block;
  vertical-align: middle;
  padding: 4px 10px 4px 3px;
  border-radius: 4px;
  margin-left: 2px;
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item:hover
  .flag-content {
  background-color: rgba(255, 255, 255, 0.3);
  /* transition: all 0.2s; */
}

.cruise_search .search_form .search-form-item img.flag {
  width: 36px;
  position: relative;
  top: -1px;
  left: 4px;
}

.cruise_search .search_form .search-form-item .flag-content .flag-text {
  display: none;
  opacity: 0;
  color: white;
  margin-left: 7px;
  /* transition: all 0.2s; */
}

.cruise_search
  .search_form
  .search-form-item
  .search-form-list
  .search-form-list-item:hover
  .flag-content
  .flag-text {
  display: inline;
  opacity: 1;
}

.cruise_search
  .search_form
  .search-form-item
  .destination-area-name
  .search-form-list-item-nochecked,
.cruise_search
  .search_form
  .search-form-item
  .destination-area-name
  .search-form-list-item-checked {
  width: 15px;
  height: 15px;
}

.cruise_search
  .search_form
  .search-form-item
  .destination-area-name
  .search-form-list-item-nochecked {
  display: inline-block;
}

.cruise_search
  .search_form
  .search-form-item
  .destination-area-name.active
  .search-form-list-item-nochecked {
  display: none;
}

.cruise_search
  .search_form
  .search-form-item
  .destination-area-name
  .search-form-list-item-checked,
.cruise_search
  .search_form
  .search-form-item
  .destination-area-name.disable
  .search-form-list-item-checked {
  display: none;
}

.cruise_search
  .search_form
  .search-form-item
  .destination-area-name.active
  .search-form-list-item-checked {
  display: inline-block;
}

.cruise_search .search_form .search-form-item .destination-area-name.disable {
  color: #87acc3;
  cursor: not-allowed;
}

.cruise_search .destination-search-form .destination-area-group,
.cruise_search .destination-search-form .destination-area {
  /* width: 165px; */
  margin-left: 0px;
}

.cruise_search .destination-search-form .destination-area-group,
.cruise_search .destination-search-form .destination-area-line {
  position: absolute;
  width: 1px;
  height: 100%;
  background-color: rgba(68, 155, 210, 0.6);
  right: 25px;
  top: 0px;
}

.cruise_search .destination-search-form .search-form-item ~ .search-form-item {
  margin-left: 0px;
}

.tran-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 9;
  display: none;
}

.cruise-not-allow-tootip .tooltip-inner,
.cruise-flag-country-tootip .tooltip-inner {
  width: 270px;
  background-color: #54a3de;
  color: white;
  padding: 5px 10px;
  font-size: 12px;
  max-width: initial;
  text-align: left;
}

.cruise-flag-country-tootip .tooltip-inner {
  width: initial;
}

.cruise_search .cruise-not-allow-tootip .tooltip-arrow,
.cruise_search .cruise-flag-country-tootip .tooltip-arrow {
  border-right-color: #54a3de;
  border-left-color: #54a3de;
}

.cruise-not-allow-tootip.in,
.cruise-flag-country-tootip.in {
  opacity: 1;
  width: initial;
}

.cruise-not-allow-tootip .tooltip-inner > div,
.cruise-flag-country-tootip .tooltip-inner > div {
  display: inline-block;
  vertical-align: top;
}

.cruise-not-allow-tootip .tooltip-inner div.tip-text,
.cruise-flag-country-tootip .tooltip-inner div.tip-text {
  width: 230px;
  /* margin-left: 5px; */
  position: relative;
  top: 1px;
}

.cruise-flag-country-tootip .tooltip-inner div.tip-text {
  width: initial;
}

.cruise_search .go-to-cruise-port {
  position: relative;
  top: 20px;
  text-align: right;
}

.cruise_search .destination-search-form .go-to-cruise-port {
  right: 10px;
}

/* ----航线搜索下拉 search_container end----- */
</style>
